"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ConnectButton;
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _cog_selected = _interopRequireDefault(require("../../assets/cog_selected.svg"));
var _marty_selected = _interopRequireDefault(require("../../assets/marty_selected.svg"));
var _connect_btnDefault = require("../../assets/connection/connect_btn-default.svg");
var _raft = require("@robotical/webapp-types/dist-types/src/types/raft");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ConnectButton(_ref) {
  let {
    onConnect,
    raftType
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.connectButton,
    onClick: onConnect,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.emptyRow
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.connectButtonIconContainer,
      children: raftType === _raft.RaftTypeE.COG ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _cog_selected.default,
        alt: "Cog icon",
        className: _stylesModule.default.connectButtonIcon
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _marty_selected.default,
        alt: "Marty icon",
        className: _stylesModule.default.connectButtonIcon
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: [_stylesModule.default.connectIconContainer].join(" "),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_connect_btnDefault.ReactComponent, {})
    })]
  });
}